(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(() => {
  let pending = false;

  function lineIdentity(variantId, sellingPlanId, properties) {
    if (!variantId) return null;
    const entries = Array.isArray(properties) ? [...properties] : Object.entries(properties || {});
    return JSON.stringify([String(variantId), String(sellingPlanId || ''), entries.sort(([a], [b]) => a.localeCompare(b))]);
  }

  function renderedLineIdentity(line) {
    try {
      return lineIdentity(line.dataset.cartVariantId, line.dataset.cartSellingPlanId, JSON.parse(line.dataset.cartProperties || 'null'));
    } catch {
      return null;
    }
  }

  // dialog:after-show does not bubble (theme.js), so only a capture listener hears it (EU PR 399). Touch screens need it: there
  // the focus trap focuses nothing, and focus stayed on the page behind the open drawer.
  document.addEventListener('dialog:after-show', event => {
    if (event.target.id === 'cart-drawer') event.target.querySelector('[data-cart-heading]')?.focus({ preventScroll: true });
  }, true);

  // A discount code that applies (or is removed) re-renders the drawer and takes the focused control with it (EU PR 399): focus
  // goes to the new "Discount code?" summary, not out of the dialog, without a ring. Never moves focus that is still somewhere.
  let discountRequest = 0;
  document.addEventListener('cart:refresh', event => {
    if (event.target.closest?.('#cart-drawer :is(cart-discount-field, cart-discount-remove-button)')) discountRequest = Date.now();
  });
  document.addEventListener('cart-drawer:refreshed', event => {
    const at = discountRequest;
    discountRequest = 0;
    if (!at || Date.now() - at > 15000 || !event.target.hasAttribute('open') || document.activeElement !== document.body) return;
    (event.target.querySelector('.resty-cart-discount-disclosure summary') || event.target.querySelector('[data-cart-heading]'))?.focus({ preventScroll: true, focusVisible: false });
  });

  async function changeQuantity(drawer, control, key, quantity) {
    if (pending || window.restyCart?.pending) return;
    const input = control.closest('line-item-quantity').querySelector('input[data-line-key]');
    input.required = true;
    if (!Number.isInteger(quantity) || quantity < 0 || (quantity > 0 && !input.checkValidity())) {
      input.reportValidity();
      input.value = input.defaultValue;
      return;
    }
    pending = true;
    // The field shows the requested number at once (minus, plus, Remove); the catch below puts the old one back.
    if (control !== input) input.value = String(quantity);
    const line = control.closest('line-item');
    const identity = renderedLineIdentity(line);
    const uniqueIdentity = identity && [...drawer.querySelectorAll('[data-cart-line-key]')].filter(item => renderedLineIdentity(item) === identity).length === 1;
    const focusSelector = control === input ? 'input[data-line-key]' : control.matches('.quantity-selector__button')
      ? `quantity-selector > .quantity-selector__button:${quantity > Number(input.defaultValue) ? 'last' : 'first'}-child`
      : 'line-item-quantity > a';
    const error = drawer.querySelector('[data-cart-error]');
    const status = drawer.querySelector('[data-cart-status]');
    error.hidden = true;
    status.textContent = status.dataset.updating;
    drawer.setAttribute('data-quantity-pending', '');
    drawer.querySelector('.cart-drawer__items').setAttribute('aria-busy', 'true');
    const checkout = drawer.querySelector('[name="checkout"]');
    checkout?.setAttribute('aria-disabled', 'true');
    const quantityInputs = [...drawer.querySelectorAll('input[data-line-key]')];
    quantityInputs.forEach(element => { element.readOnly = true; });
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
    line.dispatchEvent(new CustomEvent('line-item:will-change', { bubbles: true, detail: { targetQuantity: quantity } }));
    let refreshed;
    let refreshTimeout;
    try {
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
      const cart = await window.restyCart.change({ id: key, quantity, sections: [...new Set(sections)].join(','), sections_url: window.location.pathname }, identity);
      if (window.themeVariables.settings.pageType === 'cart') {
        window.location.reload();
        return;
      }
      const sectionHtml = cart.sections?.[drawer.dataset.sectionId];
      if (!sectionHtml || !new DOMParser().parseFromString(sectionHtml, 'text/html').querySelector('cart-drawer')) {
        window.location.assign(`${Shopify.routes.root}cart`);
        return;
      }
      let updatedItem = cart.items.find(item => item.key === key);
      if (!updatedItem && quantity > 0 && uniqueIdentity) {
        const matches = cart.items.filter(item => lineIdentity(item.variant_id, item.selling_plan_allocation?.selling_plan?.id, item.properties) === identity);
        if (matches.length === 1) updatedItem = matches[0];
      }
      const updated = new Promise((resolve, reject) => {
        refreshed = resolve;
        drawer.addEventListener('cart-drawer:refreshed', refreshed, { once: true });
        refreshTimeout = setTimeout(() => reject(new Error()), 5000);
      });
      if (updatedItem || quantity === 0) {
        line.dispatchEvent(new CustomEvent('line-item:change', { bubbles: true, detail: { quantity: updatedItem?.quantity ?? 0, cart } }));
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'line-item:change', cart } }));
      await updated;
      const currentLine = updatedItem && [...drawer.querySelectorAll('[data-cart-line-key]')].find(item => item.dataset.cartLineKey === updatedItem.key);
      let focusTarget = currentLine?.querySelector(focusSelector);
      if (focusTarget?.matches(':disabled')) focusTarget = currentLine.querySelector('input[data-line-key]');
      if (drawer.hasAttribute('open')) (focusTarget || drawer.querySelector('[data-cart-heading]'))?.focus({ preventScroll: true });
      const nextStatus = drawer.querySelector('[data-cart-status]');
      nextStatus.textContent = nextStatus.dataset.updated;
    } catch (failure) {
      input.value = input.defaultValue;
      const message = drawer.querySelector('[data-cart-error-message]');
      if (message) {
        drawer.querySelector('[data-cart-error]').hidden = false;
        message.textContent = failure?.cartMessage || message.dataset.fallback;
      }
      drawer.querySelector('[data-cart-status]').textContent = '';
    } finally {
      clearTimeout(refreshTimeout);
      if (refreshed) drawer.removeEventListener('cart-drawer:refreshed', refreshed);
      pending = false;
      drawer.removeAttribute('data-quantity-pending');
      drawer.querySelector('.cart-drawer__items')?.removeAttribute('aria-busy');
      checkout?.removeAttribute('aria-disabled');
      quantityInputs.forEach(element => { element.readOnly = false; });
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }
  }

  for (const type of ['click', 'change', 'submit']) {
    document.addEventListener(type, event => {
      const drawer = event.target.closest?.('#cart-drawer');
      if (!drawer) return;
      const inPurchaseArea = event.target.closest('.cart-drawer__items, .cart-drawer__footer, product-form');
      if (pending && inPurchaseArea) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      const control = type === 'change' ? event.target.closest('line-item-quantity input[data-line-key]') : type === 'click' ? event.target.closest('line-item-quantity a[href*="/cart/change"]') : null;
      if (!control) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const url = control.href ? new URL(control.href) : null;
      const key = url ? url.searchParams.get('id') : control.dataset.lineKey;
      const quantity = Number(url ? url.searchParams.get('quantity') : control.value.trim() || NaN);
      changeQuantity(drawer, control, key, quantity);
    }, true);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-testimonials-38"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('resty-testimonials')) {
    customElements.define('resty-testimonials', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-review-viewport]');
        if (!this.viewport) return;
        this.reviews = [...this.querySelectorAll('[data-review]')];
        this.controls = this.querySelector('[data-review-controls]');
        this.previous = this.querySelector('[data-review-prev]');
        this.next = this.querySelector('[data-review-next]');
        this.status = this.querySelector('[data-review-status]');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.viewport.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.update(), 100);
        }, { ...options, passive: true });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.target !== this.viewport) return;
          const rtl = getComputedStyle(this.viewport).direction === 'rtl';
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.goTo(event.key === 'Home' ? 0 : this.reviews.length - 1);
          }
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.reviews.findIndex((review) => review.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.goTo(index, 'auto');
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.viewport);
        this.update();
      }

      disconnectedCallback() {
        this.events?.abort();
        this.resizeObserver?.disconnect();
        clearTimeout(this.scrollTimer);
      }

      range() {
        const bounds = this.viewport.getBoundingClientRect();
        const visible = this.reviews.map((review, index) => ({ index, rect: review.getBoundingClientRect() }))
          .filter(({ rect }) => Math.min(rect.right, bounds.right) - Math.max(rect.left, bounds.left) > 8);
        return [visible[0]?.index || 0, visible.at(-1)?.index || 0];
      }

      update() {
        const overflow = this.viewport.scrollWidth - this.viewport.clientWidth > 2;
        this.controls.hidden = !overflow;
        const [first, last] = this.range();
        const bounds = this.viewport.getBoundingClientRect();
        const firstRect = this.reviews[0].getBoundingClientRect();
        const lastRect = this.reviews.at(-1).getBoundingClientRect();
        const rtl = getComputedStyle(this.viewport).direction === 'rtl';
        this.previous.setAttribute('aria-disabled', String(!overflow || (rtl ? firstRect.right <= bounds.right + 5 : firstRect.left >= bounds.left - 5)));
        this.next.setAttribute('aria-disabled', String(!overflow || (rtl ? lastRect.left >= bounds.left - 5 : lastRect.right <= bounds.right + 5)));
        const message = this.status.dataset.format.replace('[first]', first + 1).replace('[last]', last + 1).replace('[total]', this.reviews.length);
        if (this.status.textContent !== message) this.status.textContent = message;
      }

      move(direction) {
        this.update();
        const button = direction < 0 ? this.previous : this.next;
        if (button.getAttribute('aria-disabled') === 'true') return;
        this.goTo(this.range()[0] + direction);
      }

      goTo(index, behavior) {
        const review = this.reviews[Math.max(0, Math.min(index, this.reviews.length - 1))];
        const bounds = this.viewport.getBoundingClientRect();
        const rect = review.getBoundingClientRect();
        const rtl = getComputedStyle(this.viewport).direction === 'rtl';
        this.viewport.scrollBy({
          left: rtl ? rect.right - bounds.right + 4 : rect.left - bounds.left - 4,
          behavior: behavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'),
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
